/* eslint-disable radix */
import moment from 'moment';
import { sortItems } from '../utils/sortFunc';
import { format1Decimal } from '../Pages/Stock/constants';

const tableWidth = 750;
// const headerWidth = tableWidth + 50;
const cellWidth = tableWidth / 11 - 28;
const isMobile = window.innerWidth < 850 ? true : false;

// Table 1
export const homePageOptionTradecolumns = [
  {
    title: 'Size',
    keyName: 'size',
    hoverClassName: true,
    hoverColor: 'white',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'size'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        backgroundColor: 'black',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '68px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(95, 105, 175, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ticker',
    hoverClassName: true,
    hoverColor: 'purple',
    keyName: 'usymbol',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'usymbol'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '58px',
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'red', // Change the color to whatever you want
        },
      },
    },
  },
  {
    title: 'Expiry',
    keyName: 'expiry',
    hoverClassName: true,
    hoverColor: 'white',
    func: (date) => moment(date).format('DD-MMM-YY'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'expiry'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '50px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '64px', paddingRight: '5px' }
          : { color: 'white', width: '61px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '74px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(163, 208, 251, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Strike',
    keyName: 'strike',
    prefix: '$',
    func: (number) => (number ? `${number.toFixed(2)}` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'strike'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '58px', paddingRight: '5px' }
          : { color: 'white', width: '58px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'P/C',
    keyName: 'option',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'option'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Price',
    keyName: 'price',
    func: (num) => (num ? `$${num.toFixed(2)}` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'price'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '60px', paddingRight: '5px' }
          : { color: 'white', width: '60px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Side',
    keyName: 'mktside',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'mktside'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Stock',
    keyName: 'spot',
    func: (number) => (number ? number.toFixed(2) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'spot'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '60px', paddingRight: '5px' }
          : { color: 'white', width: '60px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'spot_chg',
    upDown: true,
    func: (number) => (number ? `${number.toFixed(2)}` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'spot_chg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: '0px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Condition',
    keyName: 'condition',
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'condition'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '80px', paddingRight: '5px' }
          : { color: 'white', width: '80px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Volume',
    keyName: 'volume',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'volume'),
    func: (number) => number.toLocaleString(),
    // upDown: true,
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '70px', paddingRight: '5px' }
          : { color: 'white', width: '70px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'OI',
    keyName: 'open_int',
    hoverClassName: true,
    hoverColor: 'white',
    func: (number) => number.toLocaleString(),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'open_int'),
    style: {
      headCellStyle: {
        backgroundColor: 'rgb(101, 101, 102)',
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '40px', paddingRight: '5px' }
          : { color: 'white', width: '40px' },
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(127, 211, 210, 0.5 )',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'IV',
    keyName: 'ivol',
    func: (number) => (number ? format1Decimal(number * 100) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivol'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '40px', paddingRight: '5px' }
          : { color: 'white', width: '40px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'ivol_chg',
    upDown: true,
    func: (number) => (number ? (number * 100).toFixed(1) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ivol_chg'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: '0px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Delta',
    keyName: 'delta',
    func: (number) => (number ? number.toFixed(2) : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'delta'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '60px', paddingRight: '5px' }
          : { color: 'white', width: '60px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Time',
    keyName: 'timestamp',
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'timestamp'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '40px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '60px', paddingRight: '5px' }
          : { color: 'white', width: '60px' },
      },
      bodyCellStyle: {
        padding: 0,
        minWidth: '60px',
        textAlign: 'end',
      },
    },
  },
];

// Table 2
export const HOMEPAGE_OPEN_INTEREST_COLUMNS = [
  {
    title: 'OI',
    keyName: 'open_int',
    hoverClassName: true,
    hoverColor: 'white',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'open_int'),
    func: (item) => item.toLocaleString(),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '56px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(127, 211, 210, 0.5 )',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Chg',
    keyName: 'oichg',
    upDown: true,
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'oichg'),
    func: (item) => item.toLocaleString(),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        backgroundColor: 'black',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: '0 5px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Volume',
    keyName: 'volume',
    hoverClassName: true,
    hoverColor: 'white',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'volume'),
    func: (item) => item.toLocaleString(),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '60px', paddingRight: '5px' }
          : { color: 'white', width: '60px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(95, 105, 175, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ticker',
    keyName: 'usymbol',
    hoverClassName: true,
    hoverColor: 'purple',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'usymbol'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        cursor: 'pointer',
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Expiry',
    keyName: 'expiry',
    hoverClassName: true,
    hoverColor: 'white',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'expiry'),
    func: (date) => moment(date).format('DD-MMM-YY'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '63px', paddingRight: '5px' }
          : { color: 'white', width: '63px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '60px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        background: 'rgba(163, 208, 251, 0.5)',
        cursor: 'pointer',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Strike',
    keyName: 'strike',
    prefix: '$',
    // func: (number) => number.toFixed(2),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'strike'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'P/C',
    keyName: 'put_call',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'put_call'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        width: '20px',
      },
    },
  },

  {
    title: 'Side',
    keyName: 'mktside',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'mktside'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Bid%',
    keyName: 'bid_pct',
    func: (itm) => `${parseInt(itm)}%`,
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'bid_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Mid%',
    keyName: 'mid_pct',
    func: (itm) => `${parseInt(itm)}%`,
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'mid_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Ask%',
    keyName: 'ask_pct',
    func: (itm) => `${parseInt(itm)}%`,
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'ask_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
  {
    title: 'Comments',
    keyName: 'comments',
    func: (data) => (data ? data : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'comments'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '20px',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
];
// Stock OpenInterest Columns (Table 3)
export const HOMEPAGE_SUMMARY_SECTOR_COLUMNS = [
  {
    title: 'Description',
    keyName: 'description',
    hoverClassName: true,
    hoverColor: 'purple',
    func: (item) => item.toLocaleString(),
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'description'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        backgroundColor: 'black',
        sortLabelStyle: { color: 'white', width: '67px' },
      },
      bodyCellStyle: {
        padding: 0,
        width: '200px',
        opacity: 1,
        borderRight: '1px solid #e0e0e0',
        cursor: 'pointer',
        textAlign: 'center',
      },
    },
  },
  {
    title: 'Calls',
    keyName: 'calls',
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'calls'),
    func: (item) => (item ? `${item.toLocaleString()}` : '-'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Puts',
    keyName: 'puts',
    func: (item) => (item ? item.toLocaleString() : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'puts'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '50px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '61px', paddingRight: '5px' }
          : { color: 'white', width: '61px' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        borderColor: '#C0C0C0',
        width: '20px',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Total',
    keyName: 'option_volume',
    func: (item) => (item ? item.toLocaleString() : '-'),
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'option_volume'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '78px', paddingRight: '5px' }
          : { color: 'white', width: '78px' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: '%Adv',
    keyName: 'pct_adv',
    func: (item) => (item ? `${parseInt(item)}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'pct_adv'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Tw%Adv',
    keyName: 'tw_pct_adv',
    func: (item) => (item ? `${parseInt(item)}%` : '-'),
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'tw_pct_adv'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '65px', paddingRight: '5px' }
          : { color: 'white', width: '65px' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Call%',
    keyName: 'call_pct',
    func: (num) => (num ? `${num}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'call_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', width: '50px', paddingRight: '5px' }
          : { color: 'white', width: '50px' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Put%',
    keyName: 'put_pct',
    func: (num) => (num ? `${num}%` : '-'),
    sortFunc: (arrayToSort, order) => sortItems(arrayToSort, order, 'put_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Bear%',
    keyName: 'bearish_pct',
    func: (item) => (item ? `${parseInt(item)}%` : '-'),
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'bearish_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'Bull%',
    keyName: 'bullish_pct',
    func: (item) => (item ? `${parseInt(item)}%` : '-'),
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'bullish_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },
  {
    title: 'ETF',
    keyName: 'benchmark',
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'benchmark'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
      },
    },
  },

  {
    title: 'Chg%',
    keyName: 'benchmark_chg_pct',
    func: (number) => (number ? `${format1Decimal(number * 100)}%` : '-'),
    sortFunc: (arrayToSort, order) =>
      sortItems(arrayToSort, order, 'benchmark_chg_pct'),
    style: {
      headCellStyle: {
        padding: 0,
        width: '20px',
        sortLabelStyle: isMobile
          ? { color: 'white', paddingRight: '5px' }
          : { color: 'white' },
      },
      bodyCellStyle: {
        height: 15,
        padding: 0,
        fontSize: 12,
        width: cellWidth,
        borderColor: '#C0C0C0',
        textAlign: 'end',
        paddingRight: '5px',
      },
    },
  },
];



// WEBPACK FOOTER //
// ./src/constants/homePageConstants.js